export enum EmployeesFiltersParam {
  AssignedToMe = 'assignedToMe',
  IsAdminMode = 'isAdminMode',
  SearchText = 'searchText',
  FilterByDepartments = 'filterByDepartments',
  IsSubcontractorsMode = 'isSubcontractorsMode',
}
